import React from 'react'
import { NavLink } from 'react-router-dom'
import { Navigate, Route, Routes } from 'react-router-dom'

import { Button, Modal } from 'rsuite'

import { IconButton } from '@mui/material'
import { PowerSettingsNew } from '@mui/icons-material'
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined'
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'

import Icon from '@mdi/react'
import { mdiLanguageHaskell, mdiRotateOrbit, mdiSeal, mdiStateMachine, mdiGoogleAssistant } from '@mdi/js'

import css from './main.module.scss'
import { BootstrapTooltip } from '../_ui/tooltip'
import ProfileContainer from './profile/profileContainer'
import UmkdContainer from './umkd/umkdContainer'
import SettingsContainer from './settings/settingsContainer'
import PortfolioContainer from './portfolio/portfolioContainer'
import RatingsContainer from './ratings/ratingsContainer'
import RpdContainer from './rpd/rpd.container'

const Main = (props: any) => {
    return (
        <>
            <CloseApp {...props} />

            <div className={css.main}>
                <div className={css.mainBody}>
                    <div className={css.appBar}>
                        <div className={css.logo}>
                            <Icon path={mdiLanguageHaskell} />
                        </div>

                        <div className={css.title}>АИС ЭИОС</div>

                        <div className={css.bar}>
                            <BootstrapTooltip title="Сообщения" placement="top" arrow>
                                <IconButton size="large" sx={{ color: "#5763b3", m: "auto 0" }} onClick={() => props.setDrawerVisibleMessage(true)}>
                                    <EmailOutlinedIcon />
                                </IconButton>
                            </BootstrapTooltip>

                            <BootstrapTooltip title="Выход" placement="top" arrow>
                                <IconButton size="large" sx={{ color: "#5763b3", m: "auto 0" }} onClick={() => props.setVisibleCloseApp(true)}>
                                    <PowerSettingsNew />
                                </IconButton>
                            </BootstrapTooltip>
                        </div>
                    </div>

                    <div className={css.contentBody}>
                        <div className={css.navBar}>
                            <div className={css.navBarPrimary}>
                                <NavLink to="/main/profile" style={{ margin: "auto 0" }} className={({ isActive }) => isActive ? `${css.navItemActive}` : `${css.navItem}`}>
                                    <AccountCircleOutlinedIcon />
                                    <div>Мой профиль</div>
                                </NavLink>

                                <NavLink to="/main/rpd" style={{ display: `${props.getDisabledMenuNavbar.disableRPD ? "none" : "grid"}` }} className={({ isActive }) => isActive ? `${css.navItemActive}` : `${css.navItem}`}>
                                    <Icon path={mdiGoogleAssistant} size={1} />
                                    <div>РПД</div>
                                </NavLink>

                                <NavLink to="/main/umkd" style={{ display: `${props.getDisabledMenuNavbar.disableUMKD ? "none" : "grid"}` }} className={({ isActive }) => isActive ? `${css.navItemActive}` : `${css.navItem}`}>
                                    <Icon path={mdiRotateOrbit} size={1} />
                                    <div>УМКД</div>
                                </NavLink>

                                <NavLink to="/main/ratings" style={{ display: `${props.getDisabledMenuNavbar.disableEnterRatings ? "none" : "grid"}` }} className={({ isActive }) => isActive ? `${css.navItemActive}` : `${css.navItem}`}>
                                    <Icon path={mdiStateMachine} size={1} />
                                    <div>Ввод оценок</div>
                                </NavLink>

                                <NavLink to="/main/portfolio" style={{ display: `${props.getDisabledMenuNavbar.disableStudentPortfolio ? "none" : "grid"}` }} className={({ isActive }) => isActive ? `${css.navItemActive}` : `${css.navItem}`}>
                                    <Icon path={mdiSeal} size={1} />
                                    <div>Портфолио студента</div>
                                </NavLink>
                            </div>

                            <div className={css.navBarSecondary}>
                                <NavLink to="/main/settings" style={{ display: `${props.getDisabledMenuNavbar.disableSettings ? "none" : "grid"}` }} className={({ isActive }) => isActive ? `${css.navItemActive}` : `${css.navItem}`}>
                                    <SettingsOutlinedIcon />
                                    <div>Администрирование</div>
                                </NavLink>
                            </div>
                        </div>

                        <div className={css.content}>
                            <Routes>
                                <Route path="/" element={<Navigate to="/main/profile" />} />

                                <Route path="/rpd" element={<RpdContainer disabledTab={props.getDisabledMenuNavbar.disableRPD} />} />
                                <Route path="/umkd" element={<UmkdContainer disabledTab={props.getDisabledMenuNavbar.disableUMKD} />} />
                                <Route path="/ratings" element={<RatingsContainer disabledTab={props.getDisabledMenuNavbar.disableEnterRatings} />} />
                                <Route path="/portfolio/*" element={<PortfolioContainer disabledTab={props.getDisabledMenuNavbar.disableStudentPortfolio} />} />
                                <Route path="/profile" element={<ProfileContainer />} />
                                <Route path="/settings/*" element={<SettingsContainer disabledTab={props.getDisabledMenuNavbar.disableSettings} />} />
                            </Routes>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

// Окно подтверждения закрытия приложения
const CloseApp = (props: any) => {
    return (
        <Modal backdrop="static" size="xs" autoFocus={false} open={props.visibleCloseApp}>
            <div className="modal">
                <div className="modalHead">
                    Выход из системы...
                </div>

                <div className="modalBody">
                    Вы действительно хотите выйти из системы?
                </div>

                <div className="modalFooter">
                    <Button size="md" appearance="primary" onClick={props.closeApp}>ДА</Button>
                    <Button size="md" appearance="default" onClick={() => props.setVisibleCloseApp(false)}>ОТМЕНА</Button>
                </div>
            </div>
        </Modal>
    )
}

export default Main